/** @jsxImportSource @emotion/react */
import React from "react";
import { jsx, css } from "@emotion/react";
import { useEffect, useState, forwardRef } from "react";
import ClearIcon from "@mui/icons-material/Clear";
import Swal from "sweetalert2";
import axios from "axios";
import { useHistory } from "react-router-dom";
import { DataGrid } from "@mui/x-data-grid";
import AddIcon from "@mui/icons-material/Add";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import Slide from "@mui/material/Slide";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import InputLabel from "@mui/material/InputLabel";
import FormControl from "@mui/material/FormControl";
import { loginState, configState } from "../../lib/State";
import log from "../../lib/log";
import pr from "../../lib/pr";
import CenterSelect from "../CenterSelect";
import MemberSearch from "../MemberSearch";
import {
  Select,
  MenuItem,
  AppBar,
  Toolbar,
  Typography,
  RadioGroup,
  Radio,
  FormControlLabel,
  FormLabel,
} from "@mui/material";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import MobileDatePicker from "@mui/lab/MobileDatePicker";
import LocalizationProvider from "@mui/lab/LocalizationProvider";
import AdapterDateFns from "@mui/lab/AdapterDateFns";
import { ko } from "date-fns/locale";
import moment from "moment";
import ProductSearch from "../ProductSearch";
import { lightGreen } from "@mui/material/colors";
import get_token from "../../lib/get_token";
import { setDay } from "date-fns";

const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

// 등록하기 팝업
function MemberAdd(props) {
  const { login, onClosePop, tcid_parent } = props;
  const token = get_token();
  const [method, setMethod] = useState("");
  const [name, setName] = useState(""); //*
  const [gubun, setGubun] = useState(""); //*
  const [rate, setRate] = useState(""); //*
  const [amount, setAmount] = useState(0); //*
  const [minPrice, setMinPrice] = useState(0); //*
  const [maxPrice, setMaxPrice] = useState(0); //*
  const [days, setDays] = useState(0); //*
  const [tcid, setTcid] = useState(tcid_parent);

  const [data, setData] = useState({
    tcid: tcid,
    gubun: '',
    name: '',
    txtval: '',
    intval: 0,
    memo: '',
    use_yn: 'Y'
  })

  const submit_click = async () => {

    const postData = {
      ...data,
      token: token,
      cid: login.cid,
      level: login.level,
      mcd: login.mcd,
    };

    let result = await axios.post(
      configState.api + "/gympass_admin/basecode_add",
      postData
    );
    if (result.data.success !== 1) {
      Swal.fire(result.data.msg);
      return;
    } else {
      Swal.fire({ title: "등록되었습니다.", showCloseButton: true }).then(
        (result) => {
          onClosePop();
        }
      );
    }
  };

  const update_data = (e) => {
    setData((state) => {
      return { ...state, [e.target.name]: e.target.value }
    });
  }

  return (
    <Box>
      <Box p={3}>

        {/* 센터명 */}
        <CenterSelect
          login={login}
          tcidParent={tcid_parent}
          setTcidParent={setTcid}
        />

        {/* 구분 */}
        <Box
          css={css`
            margin-top: 10px;
          `}
        >
          <TextField
            name="gubun"
            label="구분"
            size="small"
            sx={{
              width: 420,
            }}
            autoComplete="off"
            value={data.gubun}
            onChange={update_data}
          ></TextField>
        </Box>

        {/* 구분 */}
        <Box
          css={css`
            margin-top: 10px;
          `}
        >
          <TextField
            name="name"
            label="키값"
            size="small"
            sx={{
              width: "200px",
            }}
            autoComplete="off"
            value={data.name}
            onChange={update_data}
          ></TextField>
        </Box>

        {/* 문자 */}
        <Box
          css={css`
            margin-top: 10px;
          `}
        >
          <TextField
            name="txtval"
            label="문자값"
            size="small"
            autoComplete="off"
            value={data.txtval}
            sx={{ height: 110, width: 420 }}
            multiline
            rows={4}
            onChange={update_data}
          ></TextField>
        </Box>

        {/* 숫자 */}
        <Box
          css={css`
            margin-top: 10px;
          `}
        >
          <TextField
            name="intval"
            label="숫자값"
            size="small"
            sx={{
              width: "200px",
            }}
            autoComplete="off"
            value={data.intval}
            onChange={update_data}
          ></TextField>
        </Box>

        {/* 메모 */}
        <Box
          css={css`
            margin-top: 10px;
          `}
        >
          <TextField
            name="memo"
            label="메모"
            size="small"
            sx={{
              width: 420,
            }}
            autoComplete="off"
            value={data.memo}
            onChange={update_data}
          ></TextField>
        </Box>

        {/* 상태 */}
        <FormControl
          fullWidth
          css={css`
            margin-top: 10px;
          `}
        >
          <FormLabel>상태</FormLabel>
          <RadioGroup
            row
            aria-labelledby="demo-radio-buttons-group-label"
            name="use_yn"
            onChange={update_data}
            value={data.use_yn}
          >
            <FormControlLabel value="Y" control={<Radio />} label="Y" />
            <FormControlLabel value="N" control={<Radio />} label="N" />
          </RadioGroup>
        </FormControl>

        <Box
          css={css`
            text-align: center;
            margin-top: 30px;
          `}
        >
          <Button variant="contained" onClick={submit_click} sx={{ mr: 1 }}>
            등록완료
          </Button>
          <Button
            color="warning"
            variant="contained"
            css={css`
              ml:1
            `}
            onClick={onClosePop}
          >
            취소
          </Button>
        </Box>
      </Box>
    </Box>
  );
}

export default MemberAdd;